export default __webpack_public_path__ + "assets/mountains-e2c536e9.mp4";